'use client';

import { useEffect, useState } from 'react';

type Breakpoints = {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
};

const mediaQueryList = {
  mobile: '(max-width: 767px)',
  tablet: '(min-width: 768px) and (max-width: 1023px)',
  desktop: '(min-width: 1024px)',
};

export const useBreakpoints = () => {
  const [breakpoints, setBreakpoints] = useState<Breakpoints | null>(null);

  useEffect(() => {
    const mobile = window.matchMedia(mediaQueryList.mobile);
    const tablet = window.matchMedia(mediaQueryList.tablet);
    const desktop = window.matchMedia(mediaQueryList.desktop);

    const update = () =>
      setBreakpoints({
        isMobile: mobile.matches,
        isTablet: tablet.matches,
        isDesktop: desktop.matches,
      });

    update();

    mobile.addEventListener('change', update);
    tablet.addEventListener('change', update);
    desktop.addEventListener('change', update);

    return () => {
      mobile.removeEventListener('change', update);
      tablet.removeEventListener('change', update);
      desktop.removeEventListener('change', update);
    };
  }, []);

  return breakpoints;
};
